import type Phaser from 'phaser';
import type { RunSummary } from '../core/run';
import { createProgressStore, createSupabaseRemote } from '../net/progress';
import { loadContent } from '../data/content';
import { getSupabase } from '../net/supabase';
import { createLeaderboardApi } from '../net/leaderboard';
import { onRunEnded, safeLocalKv } from './flow';
import { hubState } from './ui/hub';

export function createApp(game: Phaser.Game): void {
  const client = getSupabase();
  const store = createProgressStore(client ? createSupabaseRemote(client) : null, safeLocalKv(), loadContent());
  hubState.store.value = store;
  if (client) {
    const leaderboard = createLeaderboardApi(client);
    hubState.leaderboard.value = leaderboard;
    void leaderboard.pseudo().then((p) => { hubState.pseudo.value = p; }, () => { /* pseudo par défaut conservé */ });
  }
  // méta locale visible dès le boot ; chaque nouvelle méta du store (commit local ou fusion distante) suit dans le hub
  hubState.meta.value = store.current();
  store.subscribe((m) => { hubState.meta.value = m; });
  void store.load();
  game.events.on('run:ended', (summary: RunSummary) => { void onRunEnded(store, summary, hubState); });
}
